import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { BookingService } from '../../services/booking.service';

@Component({
  selector: 'widget-search',
  templateUrl: './widget-search.component.html',
})
export class WidgetSearchComponent implements OnInit {
  listItems: [any];
  listItemsHistory: [any];
  searchHotel: any;
  selectedItem: {};
  selectedIndex = 0;
  search: any = {
    label: '',
    reqdMsg: '',
    notFoundMsg: '',
    placeholder: '',
    value: '',
    stayType: '',
    stayValue: '',
  };
  srchValCaps = "";
  isEmpty: boolean = false;
  noMatch: boolean = false;
  rootElem: any;
  closeListner: any;
  scandicHotelText = "scandic";

  @ViewChild('widgetSearch') searchElem: ElementRef;
  @Output() changed: any = new EventEmitter<{}>();
  @Output() dataChanged: any = new EventEmitter<{}>();
  @Input() hotelPage;
  constructor(private bookingService: BookingService) { }

  ngOnInit() {
    if (this.hotelPage) {
      this.bookingService.searchType = "default";
    }
    if (typeof (window) == 'undefined') {
      return;
    }
    if (window['Scandic'].bookingWidgetLabels.search) {
      this.search = window['Scandic'].bookingWidgetLabels.search;
    }
    this.search.notFoundMsg = window['Scandic'].bookingWidgetLabels.notFoundMsg ? window['Scandic'].bookingWidgetLabels.notFoundMsg : window['Scandic'].bookingWidgetLabels.search.notFoundMsg;
    if (window['Scandic'].bookingWidgetLabels.language) {
      this.bookingService.language = window['Scandic'].bookingWidgetLabels.language;
    }
    if (!this.hotelPage && this.bookingService.getSearchData('search')) {
      this.search = this.bookingService.getSearchData('search');
    }

    if (window['Scandic'].bookingWidgetData != undefined && window['Scandic'].bookingWidgetData.searchQuery) {
      this.search.stayType = window['Scandic'].bookingWidgetData.stayType == 'city' ? 'CityPage' : 'Hotel';
      this.search.stayValue = window['Scandic'].bookingWidgetData.stayValue;
      this.search.value = window['Scandic'].bookingWidgetData.searchQuery;
    }

    if (this.search.stayType && this.search.stayValue && this.search.value) {
      this.changed.emit({ valid: true, });
    }

    this.bookingService.getHotelsAndDestinations(function (): void {
      if (this.search.stayValue) {
        this.selectedItem = <any>this.bookingService.destinations.filter((data: []) => {
          return data['Id'] == this.search.stayValue;
        })[0];
        if (this.selectedItem && this.selectedItem['Id']) {
          this.search.value = this.selectedItem['Name'];
          this.search.stayType = this.selectedItem['Type'];
          this.search.stayValue = this.selectedItem['Id'];
        }
      }
    }.bind(this));

    this.rootElem = document.querySelector(".widget-search");

    // Android Firefox doesn't work with keyup events
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("firefox") > -1 && ua.indexOf("android") > -1) {
      const showSearchResults = this.showSearchResults.bind(this);
      this.searchElem.nativeElement.addEventListener("input", showSearchResults);
    }
  }

  showSearchResultsHotelPage(e) {
    if (this.hotelPage) {
      this.showSearchResults(e);
    }
  }

  showSearchResults(e) {
    this.isEmpty = !this.search.value;
    if (e.type == "keyup" && e.which != 9) {
      this.dataChanged.emit();
    }
    if (this.isEmpty) {
      this.listItems = null;
      this.noMatch = false;
      if (!this.listItemsHistory)
        this.showHistory();

      this.changed.emit({
        valid: false,
      });
      return;
    } else {
      this.addCloseListner();
    }

    const isChanged = (!this.selectedItem || this.search.value != this.selectedItem['Name']) || this.noMatch;
    if (![16, 34, 35, 36, 37, 38, 39, 40, 9, 13].includes(e.keyCode) && isChanged) {
      this.noMatch = false;
      this.listItems = <any>[];
      const searchValues = this.search.value.toLowerCase().replace("scandic ", "").trim();
      this.listItems = <any>this.bookingService.destinations.filter((data: []) => {
        let match = false;
        let multiMatch = 0;
        match = data['tokens'].indexOf(' ' + searchValues) !== -1;
        if (data["Name"]?.toLowerCase().indexOf(this.search.value.trim().toLowerCase()) != -1) {
          multiMatch++;
          if (!this.scandicHotelText.includes(this.search.value.trim().toLowerCase())) {
            match = match || !!multiMatch;
          }
        }
        data["matchLevel"] = multiMatch;
        return match;
      }).map(val => ({
          Name: val['Name'],
          Id: val['Id'],
          Type: val['Type'],
          matchLevel: val['matchLevel'],
          Url: val['Url']
        })
      ).sort((a, b) => b["matchLevel"] - a["matchLevel"]);
      this.selectedIndex = 0;

      if ((!this.listItems || this.listItems.length < 1) && !this.scandicHotelText.includes(this.search.value.trim().toLowerCase())) {
        this.noMatch = true;
        this.changed.emit({
          valid: false,
        });
      }
    }
  }

  getHighlightedName(name: string): string {
    let newName = name.replace(this.search.value, '<b>' + this.search.value + '</b>');
    return newName.replace(this.srchValCaps, '<b>' + this.srchValCaps + '</b>');
  }

  actOnKeyDown(e): void {
    if ((!this.listItems && !this.listItemsHistory) || this.noMatch)
      return;

    if ([38, 40, 9, 13].indexOf(e.keyCode) !== -1) {
      // Check for search List or history list available or not!
      const isListHasData = (this.listItems && this.listItems.length > 0) || (this.listItemsHistory && this.listItemsHistory.length > 0);
      const listLength = this.listItems ? this.listItems.length : this.listItemsHistory.length;
      if (isListHasData && (e.keyCode == 38 || e.keyCode == 40 || e.keyCode == 9 || e.keyCode == 13)) {
        if (e.keyCode == 38) {
          this.selectedIndex = (this.selectedIndex < 1) ? 0 : this.selectedIndex - 1;
          this.focusItem('up');
        } else if (e.keyCode == 40) {
          this.selectedIndex = (this.selectedIndex >= listLength - 1) ? listLength - 1 : this.selectedIndex + 1;
          this.focusItem('down');
        } else if ((e.keyCode == 9 || e.keyCode == 13) && this.selectedIndex > -1) {
          e.preventDefault();
          const selectedItem = this.listItems ? this.listItems[this.selectedIndex] : this.listItemsHistory[this.selectedIndex];
          this.selectItem(selectedItem, this.selectedIndex);
        }
      }
    }
  }

  selectItem(item: {}, index): any {
    if (item && this.search.stayValue != item['Id'])
      this.dataChanged.emit();

    if (this.noMatch)
      return;

    this.selectedIndex = index;
    this.selectedItem = item;
    this.search.stayType = this.selectedItem['Type'];
    this.search.stayValue = this.selectedItem['Id'];
    this.search.value = this.selectedItem['Name'];
    this.search.Url = this.selectedItem['Url'];
    if (this.hotelPage) {
      window.location.href = window.location.protocol + "//" + window.location.host + this.search.Url;
    }
    this.changed.emit({
      valid: true
    });
    this.isEmpty = !this.search.value;
    this.closeList();
  }

  closeList(): void {
    if (this.noMatch) {
      this.dataChanged.emit();
    }

    this.listItems = null;
    this.listItemsHistory = null;
    this.removeCloseListner();
  }

  _closeListner(e): void {
    if (e) {
      if (!this.hotelPage)
        e.preventDefault();
      else
        e.stopPropagation();
    }
    if (this.rootElem != null && !this.rootElem.contains(e.target)) {
      if (this.selectedIndex > -1 && this.listItems && this.listItems.length > 0 && !this.hotelPage)
        this.selectItem(this.listItems[this.selectedIndex], this.selectedIndex);
      else
      {
        this.closeList();
      }
    }
    this.isEmpty = false;
  }

  addCloseListner(): void {
    if (this.closeListner)
      return;

    this.closeListner = this._closeListner.bind(this);
    document.addEventListener("click", this.closeListner, false);
    document.addEventListener("keyup", this.closeListner, false);
  }

  removeCloseListner(): void {
    document.removeEventListener("click", this.closeListner, false);
    document.removeEventListener("keyup", this.closeListner, false);
    this.closeListner = null;
  }

  clearSearch(): void {
    this.searchElem.nativeElement.focus();
    this.search.value = '';
    this.selectedIndex = 0;
    this.listItems = null;
    this.noMatch = false;
    this.changed.emit({ valid: false });
    this.dataChanged.emit();
    setTimeout(function () {
      this.showHistory();
    }.bind(this), 100);
  }

  saveSearchData(): void {
    this.search.selectedItem = this.selectedItem; // To create/update search History of the User
    this.bookingService.saveSearchData(this.search, 'search');
  }

  showHistory() {
    if (!this.hotelPage) {
      const searchHistory = this.bookingService.getSearchHistory();
      if (!!this.search.value || !searchHistory)
        return;

      this.selectedIndex = -1;
      this.listItemsHistory = <any>searchHistory;
      this.addCloseListner();
    }
  }

  removeSearchEntry(index) {
    if (!this.listItemsHistory)
      return;

    this.searchElem.nativeElement.focus();
    this.listItemsHistory.splice(index, 1);
    this.bookingService.searchHistory = this.listItemsHistory;
    this.bookingService.setSearchHistory();
  }

  focusItem(type) {
    let itemList = document.querySelector('.widget-search__list');
    let item = document.querySelector('.widget-search__list .selected');
    if (type == 'down' && item && item['offsetTop'] > itemList.scrollTop + itemList.clientHeight - 2 * item.clientHeight) {
      itemList.scrollTop = itemList.scrollTop + item.clientHeight;
    } else if (type == 'up' && item && item['offsetTop'] < itemList.scrollTop + item.clientHeight) {
      itemList.scrollTop = itemList.scrollTop - item.clientHeight;
    }
  }

  hideErrorMessage() {
      if (this.hotelPage) {
        this.noMatch = false;
      }
  }
}
